class Hits {
    /**
     * Constructor
     */
    constructor(element) {
        /**
         * @type NodeList
         */
        this.element = element;
        /**
         * @type {number}
         * @private
         */
        this._scrollPosition = window.scrollY || document.documentElement.scrollTop;
        /**
         * @type {number}
         * @private
         */
        this._offsetElement = this.element.getBoundingClientRect().top;
        /**
         * @type {boolean}
         */
        this._isHit = false;
        /**
         * @type function
         */
        this.callback = () => this;
        /**
         * Init
         */
        this._init();
    }

    /**
     * Init
     * @private
     */
    _init() {
        document.addEventListener('scroll', () => this._scroll());
    }

    /**
     * Event scroll
     * @private
     */
    _scroll() {
        this._scrollPosition = window.scrollY || document.documentElement.scrollTop;
        if ((this._scrollPosition + window.innerHeight) >= this._offsetElement && !this._isHit) {
            this.hit();
            this._isHit = true;
        }
    }

    /**
     * Hit
     */
    hit() {
        if (this.element.hasAttribute('data-sloth-callback')) {
            new window[this.element.getAttribute('data-sloth-callback')]
        }

        return this.callback(this.element);
    }
}